import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueMeta from 'vue-meta'
import VueLazyload from 'vue-lazyload'
import ScrollView from 'vue-scrollview'
import VueAgile from 'vue-agile'
import VueSmoothScroll from 'vue2-smooth-scroll'
import VueTippy, { TippyComponent } from "vue-tippy";
import VueI18n from 'vue-i18n'
import translations from './mixins/translations.js'

Vue.use(ScrollView)
Vue.use(VueSmoothScroll)
Vue.use(VueTippy);
Vue.use(VueI18n);

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-server-rendered',
  tagIDKeyName: 'vmid',
})

Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1,
  listenEvents: [ 'scroll' ]
})

Vue.config.productionTip = false

Vue.use(VueAgile)
Vue.component("tippy", TippyComponent);

const i18n = new VueI18n({
  locale: 'fr', // set locale
  messages: translations, // set locale messages
})

Vue.directive('scroll', {
  inserted: function(el, binding) {
    let f = function(evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f);
      }
    }
    window.addEventListener('scroll', f);
  }
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
